export default (state = [], action) => {
  let { type, payload } = action
  switch (type) {
    case 'ACTIVE_VENDORS_DELETE':
      return state.filter(id => id !== payload)
    case 'ACTIVE_VENDORS_ADD':
      return state.some(id => id === payload) ? state : state.concat([payload])
    case 'LOGOUT':
      return []
    default:
      return state
  }
}